<template>
  <div class="chat-bot-container">
    <div
      ref="chatMessages"
      class="chat-messages"
    >
      <div
        v-for="(msg, index) in messages"
        :key="index"
        :class="['message', msg.type]"
      >
        <pre class="message-text">{{ msg.text }}</pre>
      </div>
      <div
        v-if="isLoading"
        class="message bot loading"
      >
        <span class="typing-indicator">writing answer <span>.</span><span>.</span><span>.</span></span>
      </div>
    </div>

    <div class="chat-input">
      <input
        v-model="userMessage"
        type="text"
        placeholder="Ask me anything about pets..."
        :disabled="isLoading"
        @keyup.enter="sendMessage"
      >
      <button
        :disabled="isLoading || !userMessage.trim()"
        @click="sendMessage"
      >
        <i class="fas fa-paper-plane" />
      </button>
    </div>
  </div>
</template>

<script setup>
  import { ref, nextTick } from 'vue';
  /* eslint-disable */
  const messages = ref([
    {
      type: 'bot',
      text: "Hi! I'm PetQueen AI Asistant My Name is PawBuddy. How can I help you today?",
    },
  ]);
  const userMessage = ref('');
  const isLoading = ref(false);
  const chatMessages = ref(null);
  const API_TOKEN = process.env.VUE_APP_LOCATION_API_KEY;
  const chatWithBot = async (message) => {
    try {
      const response = await fetch('https://api.petqueen.app/api/chat/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${API_TOKEN}`,
        },

        body: JSON.stringify({
          message: message,
        }),
      });

      if (!response.ok) {
        if (response.status === 400) {
          throw new Error('Lütfen bir mesaj giriniz');
        }
        if (response.status === 503) {
          throw new Error('Chat servisi şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin.');
        }
        throw new Error(`API Hatası: ${response.status}`);
      }

      const data = await response.json();

      // Backend'den gelen yeni yanıt formatına göre güncellendi
      return {
        message: data.message || data.error || 'Yanıt alınamadı',
      };
    } catch (error) {
      console.error('Chatbot Error:', error);
      throw new Error(error.message || 'Bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
    }
  };

  const sendMessage = async () => {
    if (!userMessage.value.trim() || isLoading.value) return;

    messages.value.push({ type: 'user', text: userMessage.value });
    const currentMessage = userMessage.value;
    userMessage.value = '';
    isLoading.value = true;

    try {
      const response = await chatWithBot(currentMessage);
      messages.value.push({ type: 'bot', text: response.message });
    } catch (error) {
      messages.value.push({
        type: 'error',
        text: error.message || 'Üzgünüm, bir hata oluştu.',
      });
    } finally {
      isLoading.value = false;
      await nextTick();
      chatMessages.value.scrollTop = chatMessages.value.scrollHeight;
    }
  };
</script>

<style scoped>
  .chat-bot-container {
    max-width: 800px;
    /* Genişletildi */
    margin: 20px auto;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .chat-messages {
    height: 600px;
    /* Yükseklik artırıldı */
    overflow-y: auto;
    padding: 20px;
    background: #f8f9fa;
  }

  .message {
    margin: 10px 0;
    padding: 10px 15px;
    border-radius: 15px;
    max-width: 90%;
    /* Genişletildi */
  }

  .message-text {
    margin: 0;
    white-space: pre-wrap;
    font-family: inherit;
    font-size: inherit;
    background: none;
    border: none;
    padding: 0;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }

  .user {
    background: #007bff;
    color: white;
    margin-left: auto;
    border-radius: 15px 15px 0 15px;
  }

  .bot {
    background: white;
    border: 1px solid #ddd;
    margin-right: auto;
    border-radius: 15px 15px 15px 0;
    white-space: pre-wrap;
    /* Eklendi */
    line-height: 1.5;
    /* Eklendi */
  }

  .error {
    background: #dc3545;
    color: white;
    margin: 10px auto;
    text-align: center;
  }

  .loading {
    background: #f8f9fa !important;
    border: 1px solid #e9ecef;
  }

  .typing-indicator {
    display: flex;
    align-items: center;
  }

  .typing-indicator span {
    animation: typing 1s infinite;
    margin-left: 2px;
  }

  .typing-indicator span:nth-child(2) {
    animation-delay: 0.2s;
  }

  .typing-indicator span:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes typing {
    0%,
    100% {
      opacity: 0;
    }

    50% {
      opacity: 1;
    }
  }

  .chat-input {
    display: flex;
    padding: 15px;
    background: white;
    border-top: 1px solid #ddd;
  }

  input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 20px;
    margin-right: 10px;
    outline: none;
  }

  button {
    padding: 8px 15px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
  }

  button:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
</style>
